import angular from 'angular';

angular.module('cloudX').directive('cxAddressList', function() {
  return {
    restrict: 'E',
    template: require('./addressList.html'),
    scope: {
      addressList: '=data',
      title: '@panelTitle',
      relId: '@',
      id: '@',
    },
    controller: [
      '$scope',
      'optionsSvc',
      'objectFactorySvc',
      'resourceFactorySvc',
      'flySvc',
      'relBindSvc',
      'openNewAddressSvc',
      '$anchorScroll',
      'appSettings',
      'ModalService',
      function(
        $scope,
        optionsSvc,
        objectFactorySvc,
        resourceFactorySvc,
        flySvc,
        relBindSvc,
        openNewAddressSvc,
        $anchorScroll,
        appSettings,
        ModalService,
      ) {
        var resource = resourceFactorySvc.get('address');

        $scope.adding = false;
        $scope.newAddress = null;
        $scope.newMedium = null;
        $scope.saving = false;
        $scope.appSettings = appSettings;
        $scope.cancelNew = function() {
          $scope.adding = false;
          $scope.newAddress = null;
          $scope.newMedium = null;
          return;
        };
        $scope.getDefaultCountry = function() {
          var rel = relBindSvc.relations[$scope.relId];
          if (rel) {
            if (rel.countryFieldId && rel[rel.countryFieldId].value) {
              return rel[rel.countryFieldId].value;
            }
            if (rel.country) return rel.country;
          }
          return appSettings.defaultCountry;
        };

        $scope.addNewAddress = function() {
          if (!$scope.adding) {
            $scope.adding = true;
          } else {
            $scope.adding = false;
            $scope.newAddress = null;
            $scope.newMedium = null;
          }
        };

        var addNewAddressFromOutside = function(medium) {
          $scope.adding = true;
          $scope.newMedium = medium;
          $scope.renewNewAddress();
          $anchorScroll($scope.id + '_new');
        };

        // register 'addNewAddressFromOutside' with openNewAddressSvc for use from communicationListDrv
        openNewAddressSvc.register($scope, addNewAddressFromOutside);

        $scope.renewNewAddress = function() {
          if ($scope.newMedium != null) {
            $scope.newAddress = objectFactorySvc.address($scope.newMedium);
            if ($scope.newMedium === 0)
              $scope.newAddress.postAddress.country = $scope.getDefaultCountry();
            $scope.newAddress.edit = true;
          }
        };

        const stringEquals = function(s1, s2, ignoreCase) {
          if (ignoreCase) return (s1 || '').toLowerCase() === (s2 || '').toLowerCase();
          return (s1 || '') === (s2 || '');
        };
        const postAddressEquals = function(a1, a2, ignoreCase) {
          return (
            stringEquals(a1.street1, a2.street1, ignoreCase) &&
            stringEquals(a1.street2, a2.street2, ignoreCase) &&
            stringEquals(a1.number, a2.number, ignoreCase) &&
            stringEquals(a1.box, a2.box, ignoreCase) &&
            stringEquals(a1.zipCode, a2.zipCode, ignoreCase) &&
            stringEquals(a1.city, a2.city, ignoreCase) &&
            stringEquals(a1.country, a2.country, ignoreCase)
          );
        };

        var save = function(address) {
          if ($scope.saving) return '';
          $scope.saving = true;
          address.saving = true;
          if (address.id !== '00000000-0000-0000-0000-000000000000') {
            // existing address -> update
            return resource.update(address).$promise.then(
              function(response) {
                flySvc.success('msgConfirmChange');
                address.edit = false;
                address.saving = false;
                // update rel object with changes
                relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);

                openNewAddressSvc.notifyRefresh();
                $scope.saving = false;

                if (!response.isAddressValid) {
                  dialogsSvc
                    .showOkCancel('WarningTitle', 'msgEmailAddressInvalidWarningMessage')
                    .then(function() {
                      return false;
                    });
                }

                return false;
              },
              function(error) {
                flySvc.error(error.data.code, error.data.parameters);
                $scope.saving = false;
                address.saving = false;
                return '';
              },
            );
          } else {
            // new address -> save
            return resource
              .save(
                {
                  id: $scope.relId,
                },
                address,
              )
              .$promise.then(
                function(response) {
                  flySvc.success('msgNewItemSaved');
                  $scope.addressList.push(response.address);
                  // update rel object with changes
                  relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);

                  $scope.newAddress = null;
                  $scope.newMedium = null;
                  $scope.adding = false;
                  $scope.saving = false;

                  openNewAddressSvc.notifyRefresh();
                  if (!response.isAddressValid) {
                    ModalService.showModal({
                      template: require('../dialogs/invalidEmailWarningDialog.html'),
                      controller: 'InvalidEmailWarningDialogCtrl',
                      controllerAs: 'vm',
                      locationChangeSuccess: false,
                    }).then(function(modal) {
                      modal.element.modal();
                      modal.element.on('hidden.bs.modal', function(e) {
                        modal.element.off(e); //Remove event
                        modal.element.remove(); //Remove element
                      });
                      modal.close.then(function(result) {
                        if (result) {
                          $scope.remove(response.address);
                          return true;
                        }
                        return false;
                      });
                    });
                  }
                },
                function(error) {
                  flySvc.error(error.data.code, error.data.parameters);
                  $scope.saving = false;
                  return '';
                },
              );
          }
        };

        $scope.submit = function(address, value, field) {
          if (typeof value === 'undefined') {
            if (address.errors) {
              for (var error in address.errors) {
                if (address.errors.hasOwnProperty(error) && error[0] !== '$') {
                  if (address.errors[error].code) {
                    flySvc.error(
                      address.errors[error].code,
                      angular.copy(address.errors[error].parameters),
                    );
                  }
                }
              }
            }
            return '';
          }
          address.error = address.error || {};

          if (field == 'remark') {
            address.remark = value;
          } else {
            if (address.medium === 0 || address.medium === 5) {
              if (postAddressEquals(value, address.postAddress)) return false;
              // check if duplicate
              for (var i = 0; i < $scope.addressList.length; i++) {
                if (
                  $scope.addressList[i].id !== address.id &&
                  $scope.addressList[i].medium === 0 &&
                  postAddressEquals($scope.addressList[i].postAddress, value, true)
                ) {
                  flySvc.error(2, ['address']);
                  return '';
                }
              }
              address.postAddress = value;
            } else {
              if (value === address.addressData && address !== $scope.newAddress) return false;

              // behaviour Carla wanted: save empty string = delete (for mail, phone & social as they have only 1 property: addressData)
              if (!value) {
                if (address.id && address.id !== '00000000-0000-0000-0000-000000000000') {
                  $scope.remove(address);
                } else {
                  $scope.cancelNew();
                }
                return false;
              }
              // check if duplicate
              for (var l = 0; l < $scope.addressList.length; l++) {
                if (
                  $scope.addressList[l].id !== address.id &&
                  $scope.addressList[l].medium === address.medium &&
                  $scope.addressList[l].addressData.toLowerCase() === '' + value.toLowerCase()
                ) {
                  flySvc.error(2, ['address']);
                  return '';
                }
              }
              address.addressData = value;
            }
          }

          // save
          return save(address);
        };

        $scope.remove = function(address) {
          if ($scope.saving) return '';
          if (address.id === '00000000-0000-0000-0000-000000000000') return;
          $scope.saving = true;
          address.removing = true;
          resource.delete(
            {
              id: address.id,
            },
            function(response) {
              flySvc.success('msgAddressRemoved');

              var index = $scope.addressList.indexOf(address);
              $scope.addressList.splice(index, 1);

              openNewAddressSvc.notifyRefresh();

              relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);
              $scope.saving = false;
            },
            function(error) {
              address.removing = false;
              flySvc.error(error.data.code, error.data.parameters);
              $scope.saving = false;
            },
          );
        };

        $scope.setAsMain = function(address) {
          if ($scope.saving) return '';
          if (address.isMain) {
            address.isMain = false;
            save(address);
            return;
          }
          // set isMain = false for all addresses of the same medium
          angular.forEach($scope.addressList, function(addressInList) {
            if (addressInList.medium === address.medium) addressInList.isMain = false;
          });
          address.isMain = true;
          save(address);
        };

        $scope.toggleIncludeInMagicMail = function(address) {
          address.includeInMagicMail = !address.includeInMagicMail;
          save(address);
        };

        $scope.sortAddresses = function(address) {
          var mediumSort = address.medium;
          if (address.medium === 3) mediumSort = 5;
          if (address.medium === 4) mediumSort = 3;
          if (address.medium > 5) mediumSort = `9${address.medium}`; // sort links last
          return '' + mediumSort + address.addressData;
        };
      },
    ],
  };
});
